import { useQuery, QueryFunction } from '@tanstack/react-query'
import { useFetchWithAuth } from '../session/useFetchWithAuth'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export interface UserSearchResult {
  id: string
  emailAddress: string
  firstName?: string
  lastName?: string
  accessLevel: string
  profileId?: string
}

export interface UserSearchParams {
  query: string
  limit?: number
}

export const useUserSearch = ({ query, limit = 10 }: UserSearchParams) => {
  const fetchWithAuth = useFetchWithAuth()

  const searchUsers: QueryFunction<UserSearchResult[]> = async () => {
    if (!query || query.trim().length < 2) {
      return []
    }

    try {
      const responseData = await fetchWithAuth(
        `${URL}/users/search?q=${encodeURIComponent(query)}&limit=${limit}`,
        {
          method: 'GET',
        }
      )
      return responseData.users || []
    } catch (error) {
      console.error('Error searching users:', error)
      throw error
    }
  }

  return useQuery({
    queryKey: ['userSearch', query, limit] as const,
    queryFn: searchUsers,
    retry: false,
    staleTime: 30 * 1000, // 30 seconds
    enabled: query.trim().length >= 2,
  })
}
